import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomTable from "../../components/customTable/CustomTable";
import { createMRTColumnHelper } from "material-react-table";

import DateSearchComponent from "../../components/customTable/DateSearchComponent";
import { toast } from "react-toastify";
import {
  Button,
  Card,
  CardContent,
  Grid,
  IconButton,
  TextField,
  Tooltip,
} from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { withdrawalApi } from "../../app/slices/kycUpdate/withdrawalSlice";
import axios from "axios";
import Swal from "sweetalert2";
import axiosInstance from "../../utils/axiosInstance";

export default function Withdrawal() {
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = localStorage.getItem("token");
  const [formData, setFormData] = useState({
    uniqueId: "",
    sell_txn_id: "",
  });
  // const [findWithdrawalData, setfindWithdrawalData] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const findWithdrawal = async (uniqueId, sell_txn_id) => {
    try {
      const url = `/updateWithdraw/${uniqueId}`;
      // const url = `${baseUrl}/updateWithdraw/${uniqueId}`;
      const headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      };
      const response = await axiosInstance.post(url, { sell_txn_id });
      // const response = await axios.post(url, { sell_txn_id }, { headers });
      // setfindWithdrawalData(response.data.data);
      // console.log(response.data);
      if (response.data.error === false) {
        Swal.fire({
          text: response.data.message,
          icon: "success",
          timer: 3000,
          showConfirmButton: false,
        });
        // toast.success(response.data.message);
        setFormData({ uniqueId: "", sell_txn_id: "" });
        dispatch(withdrawalApi(queryParams));
      } else {
        Swal.fire({
          text: response.data.message,
          icon: "error",
          timer: 3000,
          showConfirmButton: false,
        });

        // toast.error(response.data.message);
      }
    } catch (error) {
      // toast.error(error.response.data.message);
      Swal.fire({
        text: error.response.data.message,
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
    }
  };

  const handleSubmit = async () => {
    if (!formData.uniqueId || !formData.sell_txn_id) {
      // toast.error("Please fill in both fields");
      Swal.fire({
        // text: response.data.message,
        text: "Please fill in both fields",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
      });
      return;
    }

    await findWithdrawal(formData.uniqueId, formData.sell_txn_id);

    // console.log("Form submitted:", formData);
    // toast.success("KYC submitted successfully!");
  };

  const dispatch = useDispatch();
  const [queryParams, setQueryParams] = useState({
    startDate: null,
    endDate: null,
  });
  const handleSearch = (startDate, endDate) => {
    setQueryParams({ startDate, endDate });
  };

  useEffect(() => {
    dispatch(withdrawalApi(queryParams));
  }, [dispatch, queryParams]);

  const sliceResponse1 = useSelector(
    (state) => state.withdrawal.withdrawal.data,
  );
  const stateLoading = useSelector((state) => state.withdrawal.loading);

  // const newData = findWithdrawalData ? findWithdrawalData : sliceResponse1
  const sliceResponse = sliceResponse1?.map((item) => {
    const resultData = item.result?.data || {};

    return {
      id: item._id,
      statusCode: item.statusCode,
      message: item.message,

      // Flattened from result.data
      sellTransactionId: resultData.sellTransactionId,
      uniqueId: resultData.uniqueId,
      mobileNumber: resultData.mobileNumber,
      bankName: resultData.bankName,
      userBankId: resultData.userBankId,
      accountNumber: resultData.accountNumber,
      ifscCode: resultData.ifscCode,
      amount: resultData.amount,
      bankTransactionId: resultData.bankTransactionId,
      modeOfPayment: resultData.modeOfPayment,
      paymentDate: resultData.paymentDate,
      failureReason: resultData.failureReason,
      status: resultData.status,
      createdAt: resultData.createdAt,
      updatedAt: resultData.updatedAt,
    };
  });

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.id);
          toast?.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("status", {
      header: "Status",
      size: 30,
    }),
    columnHelper.accessor("failureReason", {
      header: "Failure Reason",
      size: 50,
      Cell: ({ cell }) => (
        <span>{cell.row.original?.failureReason || "N/A"}</span>
      ),
    }),
    columnHelper.accessor("mobileNumber", {
      header: "Mobile No",
      size: 30,
    }),
    columnHelper.accessor("uniqueId", {
      header: "uniqueId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.uniqueId);
          toast?.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.uniqueId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.uniqueId}
            </span>
          </Tooltip>
        );
      },
    }),
    columnHelper.accessor("sellTransactionId", {
      header: "sellTransactionId",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row.original.sellTransactionId);
          toast?.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row.original.sellTransactionId}>
            <span>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
              {cell.row.original.sellTransactionId}
            </span>
          </Tooltip>
        );
      },
    }),

    // columnHelper.accessor("sellTransactionId", {
    //   header: "Sell Txn ID",
    //   size: 40,
    // }),

    // columnHelper.accessor("uniqueId", {
    //   header: "Unique ID",
    //   size: 30,
    // }),

    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => cell.row.original.createdAt?.split("T")[0],
    }),

    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => cell.row.original.updatedAt?.split("T")[0],
    }),

    columnHelper.accessor("bankName", {
      header: "Bank Name",
      size: 30,
    }),

    columnHelper.accessor("userBankId", {
      header: "User Bank ID",
      size: 30,
    }),

    columnHelper.accessor("accountNumber", {
      header: "Account No.",
      size: 30,
    }),

    columnHelper.accessor("ifscCode", {
      header: "IFSC Code",
      size: 30,
    }),

    columnHelper.accessor("amount", {
      header: "Amount",
      size: 30,
    }),

    columnHelper.accessor("bankTransactionId", {
      header: "Bank Txn ID",
      size: 40,
    }),

    columnHelper.accessor("modeOfPayment", {
      header: "Payment Mode",
      size: 30,
    }),

    columnHelper.accessor("paymentDate", {
      header: "Payment Date",
      size: 30,
      Cell: ({ cell }) =>
        cell.row.original.paymentDate
          ? cell.row.original.paymentDate.split("T")[0]
          : "--",
    }),
  ];

  return (
    <>
      {/*  */}
      <DateSearchComponent onSearch={handleSearch} />

      <Card sx={{ margin: "auto", p: 0, mt: 2, mb: 3, overflow: "visible" }}>
        {/*  */}
        <CardContent>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} sm={5}>
              <TextField
                label="Unique ID"
                name="uniqueId"
                size="small"
                variant="outlined"
                value={formData.uniqueId}
                onChange={handleChange}
                fullWidth
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={5}>
              <TextField
                label="Sell Txn Id"
                name="sell_txn_id"
                size="small"
                variant="outlined"
                value={formData.sell_txn_id}
                onChange={handleChange}
                fullWidth
                autoComplete="off"
              />
            </Grid>

            <Grid item xs={12} sm={2}>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                fullWidth
                onClick={handleSubmit}
              >
                Send
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
      <CustomTable
        columns={columns}
        data={sliceResponse}
        loading={stateLoading}
        permissionKey="kycUpdate"
      />
    </>
  );
}
